import { PACE_WEB_HOSTS } from 'src/constants';

import { appEnvControl } from 'utils';

const PROMO_PATH = '/paceplusbanner';
const PROMO_LOCALES = ['en', 'sv', 'el'];
const DEFAULT_PROMO_LOCALE = 'en';

export const PACE_PROMO_MESSAGE = {
  ready: 'pace-promo:ready',
  registration: 'pace-promo:registration',
  close: 'pace-promo:close',
  openApp: 'pace-promo:open-app',
  linkClicked: 'pace-promo:link-clicked',
};

export type PacePromoRegistration = {
  raceName: string;
  startDate: string;
  endDate: string;
  city: string;
  country: string;
  distance: number;
  email: string;
};

export function pacePromoOrigin(): string {
  return PACE_WEB_HOSTS[appEnvControl.currentEnvWithDefaultDev()] || PACE_WEB_HOSTS.production;
}

export function pacePromoUrl(locale: string): string {
  const promoLocale = PROMO_LOCALES.indexOf(locale) === -1 ? DEFAULT_PROMO_LOCALE : locale;

  return `${pacePromoOrigin()}/${promoLocale}${PROMO_PATH}`;
}
